module.exports = __webpack_public_path__ + "img/TSNY_Logo_Init.86b9b3bd.svg";